// src/container/BusinessAdvisorContainer.tsx
import React, { useState as useState3, Suspense, useCallback as useCallback7 } from "react";
import Lottie from "lottie-react";

// src/assets/ba-ai-avatar.json
var ba_ai_avatar_default = { nm: "Main Scene", ddd: 0, h: 110, w: 110, meta: { g: "@lottiefiles/creator 1.80.1" }, layers: [{ ty: 4, nm: "Logo Outlines", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "19", ddd: 0, bm: 0, hasMask: false, ao: 0, ks: { a: { a: 0, k: [14, 12.52, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [55, 55] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Group 1", it: [{ ty: "sh", bm: 0, hd: false, nm: "Path 1", d: 1, ks: { a: 0, k: { c: true, i: [[0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0]], v: [[-2.503, -7.51], [-14, -7.51], [-14, -12.52], [-2.503, -12.52]] } } }, { ty: "sh", bm: 0, hd: false, nm: "Path 2", d: 1, ks: { a: 0, k: { c: false, i: [[0, 0]], o: [[0, 0]], v: [[-2.503, -12.52]] } } }, { ty: "sh", bm: 0, hd: false, nm: "Path 3", d: 1, ks: { a: 0, k: { c: true, i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-5.951, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, -5.953], [0, 0]], v: [[14, -12.515], [14, -7.512], [2.497, -7.512], [2.497, 12.52], [-2.506, 12.52], [-2.506, -1.749], [8.259, -12.515]] } } }, { ty: "mm", bm: 0, hd: false, nm: "Merge Paths 1", mm: 1 }, { ty: "fl", bm: 0, hd: false, nm: "Fill 1", c: { a: 0, k: [1, 1, 1] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [105, 105] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [14, 12.52] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 1 }, { ty: 4, nm: "glow 3", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "22", ddd: 0, bm: 0, tt: 1, hasMask: false, ao: 0, ks: { a: { a: 0, k: [-28.888, 27.309, 0] }, s: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [150, 150, 99.338], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [100, 100, 100], t: 239.998 }, { s: [150, 150, 100], t: 479.996 }] }, sk: { a: 0, k: 0 }, p: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [70.102, 40.834], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [78.352, 86.834, 0], t: 239.998 }, { s: [70.102, 40.834, 0], t: 479.996 }] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 50 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Ellipse 1", it: [{ ty: "el", bm: 0, hd: false, nm: "Ellipse Path 1", d: 1, p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80.197, 80.197] } }, { ty: "gf", bm: 0, hd: false, nm: "Gradient Fill 1", e: { a: 0, k: [40.304, 0] }, g: { p: 3, k: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0.5, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 1, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0, 1, 0.5, 0.5, 1, 0], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 0.5, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 1, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 0, 1, 0.5, 0.5, 1, 0], t: 239.998 }, { s: [0, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0.5, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 1, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0, 1, 0.5, 0.5, 1, 0], t: 479.996 }] } }, t: 2, a: { a: 0, k: 0 }, h: { a: 0, k: 0 }, s: { a: 0, k: [0, 0] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [50, 50] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [-28.888, 27.309] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 2, tp: 4 }, { ty: 4, nm: "glow 2", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "21", ddd: 0, bm: 0, tt: 1, hasMask: false, ao: 0, ks: { a: { a: 0, k: [-28.888, 27.309, 0] }, s: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [100, 100, 100], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [150, 150, 99.338], t: 239.998 }, { s: [100, 100, 100], t: 479.996 }] }, sk: { a: 0, k: 0 }, p: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [30.852, 86.834], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [37.602, 40.834, 0], t: 239.998 }, { s: [30.852, 86.834, 0], t: 479.996 }] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 50 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Ellipse 1", it: [{ ty: "el", bm: 0, hd: false, nm: "Ellipse Path 1", d: 1, p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80.197, 80.197] } }, { ty: "gf", bm: 0, hd: false, nm: "Gradient Fill 1", e: { a: 0, k: [40.304, 0] }, g: { p: 3, k: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0.5, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 1, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0, 1, 0.5, 0.5, 1, 0], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 0.5, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 1, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 0, 1, 0.5, 0.5, 1, 0], t: 239.998 }, { s: [0, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0.5, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 1, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0, 1, 0.5, 0.5, 1, 0], t: 479.996 }] } }, t: 2, a: { a: 0, k: 0 }, h: { a: 0, k: 0 }, s: { a: 0, k: [0, 0] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [50, 50] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [-28.888, 27.309] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 3, tp: 4 }, { ty: 4, nm: "mask", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "20", ddd: 0, bm: 0, hasMask: false, td: 1, ao: 0, ks: { a: { a: 0, k: [0.261, 0.475, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [55, 55] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Ellipse 1", it: [{ ty: "el", bm: 0, hd: false, nm: "Ellipse Path 1", d: 1, p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80.197, 80.197] } }, { ty: "st", bm: 0, hd: false, nm: "Stroke 1", lc: 1, lj: 1, ml: 4, o: { a: 0, k: 100 }, w: { a: 0, k: 1 }, c: { a: 0, k: [0.1294, 0.702, 0.9333] } }, { ty: "fl", bm: 0, hd: false, nm: "Fill 1", c: { a: 0, k: [0.0353, 0.0353, 0.2863] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [0.261, 0.475] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 4 }, { ty: 4, nm: "blue gradient", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "23", ddd: 0, bm: 0, hasMask: false, ao: 0, ks: { a: { a: 0, k: [0.261, 0.475, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [55, 55] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Ellipse 1", it: [{ ty: "el", bm: 0, hd: false, nm: "Ellipse Path 1", d: 1, p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80.197, 80.197] } }, { ty: "st", bm: 0, hd: false, nm: "Stroke 1", lc: 1, lj: 1, ml: 4, o: { a: 0, k: 100 }, w: { a: 0, k: 1 }, c: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0.1294, 0.702, 0.9333], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0.6784, 0.8627, 0.5686], t: 239.998 }, { s: [0.1294, 0.702, 0.9333], t: 479.996 }] } }, { ty: "gf", bm: 0, hd: false, nm: "Gradient Fill 1", e: { a: 0, k: [41.008, 0] }, g: { p: 3, k: { a: 0, k: [0, 0.03529411764705882, 0.03529411764705882, 0.28627450980392155, 0.5, 0.03529411764705882, 0.03529411764705882, 0.28627450980392155, 1, 0.03529411764705882, 0.03529411764705882, 0.28627450980392155, 0.806, 1, 0.903, 0.75, 1, 0.5] } }, t: 2, a: { a: 0, k: 0 }, h: { a: 0, k: 0 }, s: { a: 0, k: [0, 0] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [0.261, 0.475] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 5 }, { ty: 4, nm: "back light", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "18", ddd: 0, bm: 0, hasMask: false, ao: 0, ks: { a: { a: 0, k: [0.261, 0.475, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [55, 55] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Ellipse 1", it: [{ ty: "el", bm: 0, hd: false, nm: "Ellipse Path 1", d: 1, p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80.197, 80.197] } }, { ty: "fl", bm: 0, hd: false, nm: "Fill 1", c: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0.1294, 0.702, 0.9333], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0.6784, 0.8627, 0.5686], t: 239.998 }, { s: [0.1294, 0.702, 0.9333], t: 479.996 }] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [0.261, 0.475] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 6 }, { ty: 4, nm: "glow", sr: 1, st: 0, op: 480, ip: 0, hd: false, ln: "17", ddd: 0, bm: 0, hasMask: false, ao: 0, ks: { a: { a: 0, k: [0.261, 0.475, 0] }, s: { a: 0, k: [100, 100] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [55, 55] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }, shapes: [{ ty: "gr", bm: 0, hd: false, nm: "Ellipse 1", it: [{ ty: "el", bm: 0, hd: false, nm: "Ellipse Path 1", d: 1, p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80.197, 80.197] } }, { ty: "gf", bm: 0, hd: false, nm: "Gradient Fill 1", e: { a: 0, k: [40.304, 0] }, g: { p: 3, k: { a: 1, k: [{ o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0.5, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 1, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0, 1, 0.5, 0.5, 1, 0], t: 0 }, { o: { x: 0.333, y: 0 }, i: { x: 0.667, y: 1 }, s: [0, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 0.5, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 1, 0.6784313725490196, 0.8627450980392157, 0.5686274509803921, 0, 1, 0.5, 0.5, 1, 0], t: 239.998 }, { s: [0, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0.5, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 1, 0.12941176470588237, 0.7019607843137254, 0.9333333333333333, 0, 1, 0.5, 0.5, 1, 0], t: 479.996 }] } }, t: 2, a: { a: 0, k: 0 }, h: { a: 0, k: 0 }, s: { a: 0, k: [0, 0] }, r: 1, o: { a: 0, k: 100 } }, { ty: "tr", a: { a: 0, k: [0, 0] }, s: { a: 0, k: [135, 135] }, sk: { a: 0, k: 0 }, p: { a: 0, k: [0.261, 0.475] }, r: { a: 0, k: 0 }, sa: { a: 0, k: 0 }, o: { a: 0, k: 100 } }] }], ind: 7 }], v: "5.7.0", fr: 60, op: 480, ip: 0, assets: [] };

// src/container/BusinessAdvisorContainer.tsx
import {
  AdvisorModal,
  AdvisorModalContent,
  ErrorBoundary,
  BusinessAdvisorButton,
  Loader,
  BUTTON_TEST_ID,
  Button,
  DELAYS,
  useIsMobile,
  useIsMobileOverlayOpen
} from "@tasama/ui";
import { Suggestions } from "@tasama/ui";

// src/hooks/useBusinessAdvisorInit.ts
import { useCallback } from "react";
import { useApiMutation } from "@tasama/api-client-query";
import { useTranslation } from "@tasama/i18n";

// src/store/useBusinessAdvisorStore.ts
import { createPersistedStore } from "@tasama/utils";
var initialState = {
  conversationSessionId: null,
  messages: [],
  isInitialized: false,
  context: null,
  title: null,
  subtitle: null,
  nextActions: [],
  sendMessageError: null,
  cta: [],
  selectedServiceName: null,
  ctaMetadata: null,
  tabOverride: null,
  relatedServiceOverride: null,
  recordIdOverride: null,
  hierarchyPathOverride: null,
  shouldOpen: false,
  pendingPrompt: null
};
var BA_STORE_SESSION_KEY = "store-business-advisor";
var clearBusinessAdvisorSession = () => {
  useBusinessAdvisorStore.getState().resetStore();
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(BA_STORE_SESSION_KEY);
  }
};
var useBusinessAdvisorStore = createPersistedStore(
  "business-advisor",
  initialState,
  (set, get) => ({
    setConversationSessionId: (id) => {
      set({ conversationSessionId: id });
    },
    setMessages: (messages) => {
      set({ messages });
    },
    addMessage: (message) => {
      const { messages } = get();
      const updatedMessages = [...messages, message];
      set({ messages: updatedMessages });
    },
    setContext: (context) => {
      const currentContext = get().context;
      if (JSON.stringify(currentContext) !== JSON.stringify(context)) {
        set({ context });
      }
    },
    setIsInitialized: (initialized) => {
      set({ isInitialized: initialized });
    },
    setError: (error) => {
      const errorMessage = error ? typeof error === "string" ? error : error.message : null;
      set({ error: errorMessage });
    },
    setSendMessageError: (error) => {
      set({ sendMessageError: error });
    },
    setLoading: (loading) => {
      set({ loading });
    },
    setTitle: (title) => {
      set({ title });
    },
    setSubtitle: (subtitle) => {
      set({ subtitle });
    },
    setNextActions: (nextActions) => {
      set({ nextActions });
    },
    setCta: (cta) => {
      set({ cta });
    },
    setSelectedServiceName: (name) => {
      set({ selectedServiceName: name });
    },
    setCtaMetadata: (metadata) => {
      set({ ctaMetadata: metadata });
    },
    setTabOverride: (tab) => {
      set({ tabOverride: tab });
    },
    setRelatedServiceOverride: (service) => {
      set({ relatedServiceOverride: service });
    },
    setRecordIdOverride: (recordId) => {
      set({ recordIdOverride: recordId });
    },
    setHierarchyPathOverride: (path) => {
      set({ hierarchyPathOverride: path });
    },
    setShouldOpen: (open) => {
      set({ shouldOpen: open });
    },
    setPendingPrompt: (prompt) => {
      set({ pendingPrompt: prompt });
    },
    clearConversation: () => {
      set({
        conversationSessionId: null,
        messages: [],
        isInitialized: false,
        error: null,
        sendMessageError: null,
        title: null,
        subtitle: null,
        nextActions: [],
        cta: [],
        selectedServiceName: null,
        ctaMetadata: null
      });
    },
    resetStore: () => {
      set({
        ...initialState,
        loading: false,
        error: null,
        sendMessageError: null
      });
    },
    getMessageById: (messageId) => {
      const { messages } = get();
      return messages.find((msg) => msg.id === messageId) || null;
    },
    getMessagesByRole: (role) => {
      const { messages } = get();
      return messages.filter((msg) => msg.role === role);
    },
    getLatestMessage: () => {
      const { messages } = get();
      return messages.length > 0 ? messages[messages.length - 1] : null;
    },
    hasActiveConversation: () => {
      const { conversationSessionId, isInitialized } = get();
      return Boolean(conversationSessionId && isInitialized);
    }
  }),
  {
    partialize: (state) => ({
      conversationSessionId: state.conversationSessionId,
      context: state.context,
      isInitialized: state.isInitialized
    }),
    // Ensure ephemeral fields are never carried over from a persisted session,
    // even if they were accidentally included in the partialize whitelist.
    onRehydrateStorage: () => (state) => {
      if (state) {
        state.shouldOpen = false;
        state.pendingPrompt = null;
      }
    },
    version: 2
  }
);

// src/utils/enums.ts
var BA_RELATED_SERVICE_BUSINESS_LANDING = "Tasama Business Landing";
var PortalPage = /* @__PURE__ */ ((PortalPage2) => {
  PortalPage2["PORTAL_HOME"] = "PORTAL_HOME";
  PortalPage2["PORTAL_SERVICE_CATALOGUE"] = "PORTAL_SERVICE_CATALOGUE";
  PortalPage2["PORTAL_MY_SERVICES"] = "PORTAL_MY_SERVICES";
  PortalPage2["SR_ACTIVITIES"] = "SR_ACTIVITIES";
  PortalPage2["PORTAL_SUPPORT_TICKETS"] = "PORTAL_SUPPORT_TICKETS";
  PortalPage2["PORTAL_MY_ACCOUNT"] = "PORTAL_MY_ACCOUNT";
  PortalPage2["PORTAL_NOTIFICATIONS"] = "PORTAL_NOTIFICATIONS";
  PortalPage2["ACTIVITY_REQUEST_FORM"] = "ACTIVITY_REQUEST_FORM";
  PortalPage2["NDA"] = "NDA";
  PortalPage2["KYB"] = "KYB";
  PortalPage2["MSA"] = "MSA";
  return PortalPage2;
})(PortalPage || {});
var ServiceCatalogueTabs = /* @__PURE__ */ ((ServiceCatalogueTabs3) => {
  ServiceCatalogueTabs3["L0"] = "L0";
  ServiceCatalogueTabs3["L1"] = "L1";
  ServiceCatalogueTabs3["L3"] = "L3";
  return ServiceCatalogueTabs3;
})(ServiceCatalogueTabs || {});
var MyServicesTabs = /* @__PURE__ */ ((MyServicesTabs2) => {
  MyServicesTabs2["REQUESTED"] = "REQUESTED";
  MyServicesTabs2["ACTIVE"] = "ACTIVE";
  MyServicesTabs2["COMPLETED"] = "COMPLETED";
  return MyServicesTabs2;
})(MyServicesTabs || {});
var SupportTicketsTabs = /* @__PURE__ */ ((SupportTicketsTabs2) => {
  SupportTicketsTabs2["OPEN_TICKETS"] = "OPEN_TICKETS";
  SupportTicketsTabs2["CLOSED_TICKETS"] = "CLOSED_TICKETS";
  SupportTicketsTabs2["NEW_TICKET"] = "NEW_TICKET";
  SupportTicketsTabs2["EXISTING_TICKET"] = "EXISTING_TICKET";
  return SupportTicketsTabs2;
})(SupportTicketsTabs || {});
var MyAccountTabs = /* @__PURE__ */ ((MyAccountTabs2) => {
  MyAccountTabs2["MY_DETAILS"] = "MY_DETAILS";
  MyAccountTabs2["COMPANY_DETAILS"] = "COMPANY_DETAILS";
  MyAccountTabs2["MY_TEAM"] = "MY_TEAM";
  MyAccountTabs2["DOCUMENTS"] = "DOCUMENTS";
  return MyAccountTabs2;
})(MyAccountTabs || {});
var NdaTabs = /* @__PURE__ */ ((NdaTabs3) => {
  NdaTabs3["DOWNLOAD_NDA"] = "DOWNLOAD_NDA";
  NdaTabs3["UPLOAD_SIGNED_NDA"] = "UPLOAD_SIGNED_NDA";
  return NdaTabs3;
})(NdaTabs || {});
var KybTabs = /* @__PURE__ */ ((KybTabs3) => {
  KybTabs3["COMPANY_DETAILS"] = "COMPANY_DETAILS";
  KybTabs3["UPLOAD_DOCUMENTS"] = "UPLOAD_DOCUMENTS";
  return KybTabs3;
})(KybTabs || {});
var MsaTabs = /* @__PURE__ */ ((MsaTabs3) => {
  MsaTabs3["UPLOAD_SOW"] = "UPLOAD_SOW";
  MsaTabs3["REVIEW_DRAFT"] = "REVIEW_DRAFT";
  MsaTabs3["SIGN_DRAFT"] = "SIGN_DRAFT";
  return MsaTabs3;
})(MsaTabs || {});
var RequestedServiceTabs = /* @__PURE__ */ ((RequestedServiceTabs3) => {
  RequestedServiceTabs3["UPLOAD_SOW"] = "UPLOAD_SOW";
  RequestedServiceTabs3["PROPOSAL"] = "PROPOSAL";
  RequestedServiceTabs3["REVIEW_PROPOSAL"] = "REVIEW_PROPOSAL";
  RequestedServiceTabs3["CONTRACT"] = "CONTRACT";
  RequestedServiceTabs3["REVIEW_CONTRACT"] = "REVIEW_CONTRACT";
  RequestedServiceTabs3["SIGN_CONTRACT"] = "SIGN_CONTRACT";
  RequestedServiceTabs3["PO"] = "PO";
  RequestedServiceTabs3["UPLOAD_PO"] = "UPLOAD_PO";
  RequestedServiceTabs3["REVIEW_MSA"] = "REVIEW_MSA";
  RequestedServiceTabs3["SERVICE_ACTIVATION"] = "SERVICE_ACTIVATION";
  return RequestedServiceTabs3;
})(RequestedServiceTabs || {});
var ServiceDetailTabs = /* @__PURE__ */ ((ServiceDetailTabs2) => {
  ServiceDetailTabs2["ACTIVITIES"] = "ACTIVITIES";
  ServiceDetailTabs2["SUPPORT_TICKETS"] = "SUPPORT_TICKETS";
  ServiceDetailTabs2["DOCUMENTS"] = "DOCUMENTS";
  ServiceDetailTabs2["INVOICES"] = "INVOICES";
  ServiceDetailTabs2["ACTIVITY_REQUESTS"] = "ACTIVITY_REQUESTS";
  ServiceDetailTabs2["ACTIVITY_REQUEST_DETAILS"] = "ACTIVITY_REQUEST_DETAILS";
  return ServiceDetailTabs2;
})(ServiceDetailTabs || {});
var BusinessLandingTabs = /* @__PURE__ */ ((BusinessLandingTabs2) => {
  BusinessLandingTabs2["KICKOFF_DOCUMENTATION"] = "KICKOFF_DOCUMENTATION";
  BusinessLandingTabs2["GENERAL_MANAGER_INFORMATION"] = "GM_INFO";
  BusinessLandingTabs2["COMPANY_DETAILS"] = "COMPANY_DETAILS";
  BusinessLandingTabs2["COMPANY_SETUP"] = "COMPANY_SETUP";
  BusinessLandingTabs2["BUSINESS_ACTIVITIES"] = "BUSINESS_ACTIVITIES";
  BusinessLandingTabs2["DOCUMENT_ATTESTATION_APOSTILLE"] = "DOCUMENT_ATTESTATION_APOSTILLE";
  BusinessLandingTabs2["DOCUMENT_ATTESTATION_SUBMISSION"] = "DOCUMENT_ATTESTATION_SUBMISSION";
  BusinessLandingTabs2["MOFA_ATTESTATION"] = "MOFA_ATTESTATION";
  BusinessLandingTabs2["MOJ_ATTESTATION"] = "MOJ_ATTESTATION";
  BusinessLandingTabs2["FINAL_DOCUMENTS_PACKAGE"] = "FINAL_DOCUMENTS_PACKAGE";
  BusinessLandingTabs2["TRADE_NAME_REGISTERED"] = "TRADE_NAME_REGISTERED";
  BusinessLandingTabs2["MISA_LICENSE_ISSUED"] = "MISA_LICENSE_ISSUED";
  BusinessLandingTabs2["ARTICLES_OF_ASSOCIATION_PREPARATION"] = "ARTICLES_OF_ASSOCIATION_PREPARATION";
  BusinessLandingTabs2["AOA_CR_ISSUED"] = "AOA_CR_ISSUED";
  BusinessLandingTabs2["GOVERNMENT_PLATFORM_REGISTRATION"] = "GOVERNMENT_PLATFORM_REGISTRATION";
  BusinessLandingTabs2["GM_VISA_INITIATION"] = "GM_VISA_INITIATION";
  BusinessLandingTabs2["GM_VISA_ATTESTATION"] = "GM_VISA_ATTESTATION";
  BusinessLandingTabs2["GM_TRAVELS_TO_KSA"] = "GM_TRAVELS_TO_KSA";
  BusinessLandingTabs2["IQAMA_ISSUANCE"] = "IQAMA_ISSUANCE";
  BusinessLandingTabs2["COMMERCIAL_REGISTRATION_UPDATE"] = "COMMERCIAL_REGISTRATION_UPDATE";
  BusinessLandingTabs2["WORKFORCE_PAYROLL_REGISTRATION"] = "WORKFORCE_PAYROLL_REGISTRATION";
  BusinessLandingTabs2["BANK_ACCOUNT_OPENING"] = "BANK_ACCOUNT_OPENING";
  BusinessLandingTabs2["COMPANY_ACTIVATED"] = "COMPANY_ACTIVATED";
  BusinessLandingTabs2["DOWNLOAD_INVOICE"] = "DOWNLOAD_INVOICE";
  BusinessLandingTabs2["UPLOAD_PROOF_OF_PAYMENT"] = "UPLOAD_PROOF_OF_PAYMENT";
  return BusinessLandingTabs2;
})(BusinessLandingTabs || {});

// src/utils/mappings.ts
var URL_TO_PAGE_MAP = {
  "/": "PORTAL_HOME" /* PORTAL_HOME */,
  "/home": "PORTAL_HOME" /* PORTAL_HOME */,
  "/service-catalogue": "PORTAL_SERVICE_CATALOGUE" /* PORTAL_SERVICE_CATALOGUE */,
  "/my-services": "PORTAL_MY_SERVICES" /* PORTAL_MY_SERVICES */,
  "/services": "PORTAL_MY_SERVICES" /* PORTAL_MY_SERVICES */,
  "/services/requested": "SR_ACTIVITIES" /* SR_ACTIVITIES */,
  "/services/active": "SR_ACTIVITIES" /* SR_ACTIVITIES */,
  "/services/completed": "SR_ACTIVITIES" /* SR_ACTIVITIES */,
  "/business-landing": "SR_ACTIVITIES" /* SR_ACTIVITIES */,
  "/support-tickets": "PORTAL_SUPPORT_TICKETS" /* PORTAL_SUPPORT_TICKETS */,
  "/my-account": "PORTAL_MY_ACCOUNT" /* PORTAL_MY_ACCOUNT */,
  "/notifications": "PORTAL_NOTIFICATIONS" /* PORTAL_NOTIFICATIONS */,
  "/nda": "NDA" /* NDA */,
  "/kyb": "KYB" /* KYB */,
  "/msa": "MSA" /* MSA */,
  "/activity-request": "ACTIVITY_REQUEST_FORM" /* ACTIVITY_REQUEST_FORM */
};
var PAGE_TAB_MAPPINGS = {
  ["PORTAL_MY_SERVICES" /* PORTAL_MY_SERVICES */]: {
    defaultTab: "REQUESTED" /* REQUESTED */,
    validTabs: Object.values(MyServicesTabs),
    urlParamName: "tab",
    urlToTabMap: {
      requested: "REQUESTED" /* REQUESTED */,
      active: "ACTIVE" /* ACTIVE */,
      completed: "COMPLETED" /* COMPLETED */
    }
  },
  ["PORTAL_SUPPORT_TICKETS" /* PORTAL_SUPPORT_TICKETS */]: {
    defaultTab: "OPEN_TICKETS" /* OPEN_TICKETS */,
    validTabs: Object.values(SupportTicketsTabs),
    urlParamName: "view",
    urlToTabMap: {
      open: "OPEN_TICKETS" /* OPEN_TICKETS */,
      closed: "CLOSED_TICKETS" /* CLOSED_TICKETS */,
      new: "NEW_TICKET" /* NEW_TICKET */,
      existing: "EXISTING_TICKET" /* EXISTING_TICKET */
    }
  },
  ["PORTAL_MY_ACCOUNT" /* PORTAL_MY_ACCOUNT */]: {
    defaultTab: "MY_DETAILS" /* MY_DETAILS */,
    validTabs: Object.values(MyAccountTabs),
    urlParamName: "tab",
    urlToTabMap: {
      "my-details": "MY_DETAILS" /* MY_DETAILS */,
      "company-details": "COMPANY_DETAILS" /* COMPANY_DETAILS */,
      "my-team": "MY_TEAM" /* MY_TEAM */,
      documents: "DOCUMENTS" /* DOCUMENTS */
    }
  },
  ["SR_ACTIVITIES" /* SR_ACTIVITIES */]: {
    defaultTab: null,
    validTabs: Object.values(ServiceDetailTabs),
    urlParamName: "tab",
    urlToTabMap: {
      activities: "ACTIVITIES" /* ACTIVITIES */,
      support_tickets: "SUPPORT_TICKETS" /* SUPPORT_TICKETS */,
      documents: "DOCUMENTS" /* DOCUMENTS */,
      invoices: "INVOICES" /* INVOICES */
    }
  }
};

// src/utils/url.ts
var getPageFromUrl = (url) => {
  let pathname;
  try {
    pathname = new URL(url).pathname;
  } catch {
    pathname = url.split("?")[0]?.split("#")[0] || "/";
  }
  const exactMatch = URL_TO_PAGE_MAP[pathname];
  if (exactMatch) {
    return exactMatch;
  }
  let bestMatch = null;
  let bestMatchLength = 0;
  for (const [path, page] of Object.entries(URL_TO_PAGE_MAP)) {
    if (path !== "/" && pathname.startsWith(path) && path.length > bestMatchLength) {
      bestMatch = page;
      bestMatchLength = path.length;
    }
  }
  return bestMatch ?? "PORTAL_HOME" /* PORTAL_HOME */;
};
var getTabFromUrl = (url, page) => {
  const pageConfig = PAGE_TAB_MAPPINGS[page];
  if (!pageConfig) {
    return null;
  }
  const searchString = url.includes("?") ? url.split("?")[1]?.split("#")[0] : "";
  const tabParam = new URLSearchParams(searchString).get(
    pageConfig.urlParamName
  );
  if (tabParam && pageConfig.urlToTabMap[tabParam]) {
    return pageConfig.urlToTabMap[tabParam];
  }
  return pageConfig.defaultTab;
};
var createLoggedInContext = (url) => {
  const current_page = getPageFromUrl(url);
  const current_tab = getTabFromUrl(url, current_page);
  return { current_page, current_tab };
};
var createLoggedInContextFromLocation = () => createLoggedInContext(window.location.href);
var getBusinessAdvisorUrl = (endpoint, isAuthenticated) => {
  const baseUrl = isAuthenticated ? "/business-advisor-user" : "/business-advisor";
  return `${baseUrl}${endpoint}`;
};

// src/utils/context.ts
import { CurrentPage, CompanyType } from "@tasama/ui";
var mapLoggedInContextToCurrentPage = (context) => {
  switch (context.current_page) {
    case "PORTAL_HOME" /* PORTAL_HOME */:
      return CurrentPage.PORTAL_HOME;
    case "PORTAL_SERVICE_CATALOGUE" /* PORTAL_SERVICE_CATALOGUE */:
      return CurrentPage.PORTAL_SERVICE_CATALOGUE;
    case "PORTAL_MY_SERVICES" /* PORTAL_MY_SERVICES */:
      return CurrentPage.PORTAL_MY_SERVICES;
    case "SR_ACTIVITIES" /* SR_ACTIVITIES */:
      return CurrentPage.SR_ACTIVITIES;
    case "PORTAL_SUPPORT_TICKETS" /* PORTAL_SUPPORT_TICKETS */:
      return CurrentPage.PORTAL_SUPPORT_TICKETS;
    case "PORTAL_MY_ACCOUNT" /* PORTAL_MY_ACCOUNT */:
      return CurrentPage.PORTAL_MY_ACCOUNT;
    case "PORTAL_NOTIFICATIONS" /* PORTAL_NOTIFICATIONS */:
      return CurrentPage.PORTAL_NOTIFICATIONS;
    case "NDA" /* NDA */:
      return CurrentPage.NDA;
    case "KYB" /* KYB */:
      return CurrentPage.KYB;
    case "MSA" /* MSA */:
      return CurrentPage.MSA;
    case "ACTIVITY_REQUEST_FORM" /* ACTIVITY_REQUEST_FORM */:
      return CurrentPage.ACTIVITY_REQUEST_FORM;
    default:
      return CurrentPage.PORTAL;
  }
};
var detectCurrentPage = (url, isAuthenticated, stepperCurrentStep) => {
  if (isAuthenticated) {
    const context = createLoggedInContext(url);
    return mapLoggedInContextToCurrentPage(context);
  }
  if (url.toLowerCase().includes("login")) return CurrentPage.LOGIN;
  if (stepperCurrentStep) {
    const stepToPageMap = {
      "company-type": CurrentPage.ONBOARDING_COMPANY_TYPE,
      "your-details": CurrentPage.ONBOARDING_YOUR_DETAILS,
      "upload-documents": CurrentPage.ONBOARDING_UPLOAD_DOCUMENTS,
      "company-details": CurrentPage.ONBOARDING_COMPANY_DETAILS,
      "service-needs": CurrentPage.ONBOARDING_SERVICE_NEEDS
    };
    return stepToPageMap[stepperCurrentStep] || CurrentPage.LOGIN;
  }
  return CurrentPage.LOGIN;
};
var mapCompanyTypeForApi = (companyType, companyStatus) => {
  if (companyType === "pif-owned") {
    switch (companyStatus) {
      case "PIF_ESTABLISHED":
        return CompanyType.PIF_ESTABLISHED;
      case "PIF_UNDER_DEVELOPMENT":
        return CompanyType.PIF_PROJECT;
      default:
        return CompanyType.ANONYMOUS;
    }
  }
  switch (companyType) {
    case "KSA_PRIVATE":
      return CompanyType.KSA_PRIVATE;
    case "INTERNATIONAL":
      return CompanyType.INTERNATIONAL;
    default:
      return CompanyType.ANONYMOUS;
  }
};
var createContext = (currentPage, companyType, currentTab, relatedService, recordId, hierarchyPath) => ({
  current_page: currentPage,
  current_tab: currentTab ?? null,
  related_service: relatedService ?? null,
  company_type: companyType,
  record_id: recordId ?? null,
  hierarchy_path: hierarchyPath ?? null
});

// src/utils/pageDetection.ts
var detectPageContext = ({
  url,
  isAuthenticated,
  stepperCurrentStep
}) => {
  const currentPage = detectCurrentPage(
    url,
    isAuthenticated,
    stepperCurrentStep
  );
  if (!isAuthenticated) {
    return { currentPage, currentTab: null };
  }
  const page = getPageFromUrl(url);
  const currentTab = getTabFromUrl(url, page);
  return { currentPage, currentTab };
};

// src/utils/cta.ts
import { PORTAL_ROUTES, EXTERNAL_ROUTES } from "@tasama/config";
import { i18n } from "@tasama/i18n";
var getCTAMappings = (onboardingUrl) => ({
  HOME: {
    label: i18n.t("businessAdvisor.cta.home"),
    url: PORTAL_ROUTES.HOME,
    i18nKey: "businessAdvisor.cta.home"
  },
  ONBOARDING: {
    label: i18n.t("businessAdvisor.cta.registerNow"),
    url: onboardingUrl,
    i18nKey: "businessAdvisor.cta.registerNow"
  },
  RESET_PASSWORD: {
    label: i18n.t("businessAdvisor.cta.resetPassword"),
    url: PORTAL_ROUTES.FORGOT_PASSWORD,
    i18nKey: "businessAdvisor.cta.resetPassword"
  },
  CONTACT_ME: {
    label: i18n.t("businessAdvisor.cta.contactMe"),
    url: EXTERNAL_ROUTES.CONTACT_ME,
    i18nKey: "businessAdvisor.cta.contactMe"
  },
  SUPPORT_TICKET: {
    label: i18n.t("businessAdvisor.cta.supportTicket"),
    url: PORTAL_ROUTES.SUPPORT_TICKETS,
    i18nKey: "businessAdvisor.cta.supportTicket"
  },
  SERVICE_CATALOGUE: {
    label: i18n.t("businessAdvisor.cta.serviceCatalogue"),
    url: PORTAL_ROUTES.SERVICE_CATALOGUE,
    i18nKey: "businessAdvisor.cta.serviceCatalogue"
  },
  NOTIFICATIONS: {
    label: i18n.t("businessAdvisor.cta.notifications"),
    url: PORTAL_ROUTES.NOTIFICATIONS,
    i18nKey: "businessAdvisor.cta.notifications"
  },
  MY_ACCOUNT: {
    label: i18n.t("businessAdvisor.cta.myAccount"),
    url: PORTAL_ROUTES.MY_ACCOUNT,
    i18nKey: "businessAdvisor.cta.myAccount"
  },
  MY_DOCUMENTS: {
    label: i18n.t("businessAdvisor.cta.myDocuments"),
    url: `${PORTAL_ROUTES.MY_ACCOUNT}?tab=documents`,
    i18nKey: "businessAdvisor.cta.myDocuments"
  },
  MY_SERVICES: {
    label: i18n.t("businessAdvisor.cta.myServices"),
    url: PORTAL_ROUTES.SERVICES,
    i18nKey: "businessAdvisor.cta.myServices"
  }
});
var mapCtaToItems = (ctaTypes, onboardingUrl, ctaMetadata) => {
  const mappings = getCTAMappings(onboardingUrl);
  return ctaTypes.map((type) => {
    const mapping = mappings[type];
    return {
      label: mapping?.label,
      url: mapping?.url,
      type,
      ...type === "SUPPORT_TICKET" && ctaMetadata ? { cta_metadata: ctaMetadata } : {}
    };
  });
};

// src/utils/message.ts
var MAX_CHARACTERS = 2e3;
var generateMessageId = () => `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

// src/utils/store.ts
var resetBusinessAdvisorConversation = () => {
  useBusinessAdvisorStore.getState().resetStore();
};
var setBACurrentTab = (tab) => {
  useBusinessAdvisorStore.getState().setTabOverride(tab);
};
var setBARelatedService = (service) => {
  useBusinessAdvisorStore.getState().setRelatedServiceOverride(service);
};
var triggerBAWithPrompt = (prompt) => {
  useBusinessAdvisorStore.getState().setPendingPrompt(prompt);
  useBusinessAdvisorStore.getState().setShouldOpen(true);
};

// src/hooks/useBusinessAdvisorInit.ts
var useBusinessAdvisorInit = (isAuthenticated = false) => {
  const { t } = useTranslation("common");
  const {
    setConversationSessionId,
    setIsInitialized,
    setLoading,
    setError,
    setContext,
    setTitle,
    setSubtitle,
    setNextActions
  } = useBusinessAdvisorStore();
  const initMutation = useApiMutation(getBusinessAdvisorUrl("/init", isAuthenticated), "POST", {
    onSuccess: (data) => {
      const responseData = data.data || data;
      if (responseData.conversation_session_id) {
        setConversationSessionId(responseData.conversation_session_id);
        setIsInitialized(true);
        setError(null);
        if (responseData.title) {
          setTitle(responseData.title);
        }
        if (responseData.subtitle) {
          setSubtitle(responseData.subtitle);
        }
        if (responseData.next_actions) {
          setNextActions(responseData.next_actions);
        }
      } else {
        setError({
          message: t("businessAdvisor.errors.noSessionId"),
          code: "INIT_FAILED"
        });
      }
    },
    onError: (error) => {
      setError({
        message: error.message || t("businessAdvisor.errors.initConversation"),
        code: error.code,
        details: error.details
      });
      setIsInitialized(false);
    }
  });
  const initConversation = useCallback(
    async (context) => {
      try {
        setLoading(true);
        setError(null);
        setContext(context);
        await initMutation.mutateAsync({ context });
        return true;
      } catch {
        return false;
      } finally {
        setLoading(false);
      }
    },
    [initMutation, setLoading, setError, setContext]
  );
  return {
    initConversation,
    isLoading: initMutation.isPending,
    error: useBusinessAdvisorStore((state) => state.error),
    isInitialized: useBusinessAdvisorStore((state) => state.isInitialized)
  };
};

// src/hooks/useBusinessAdvisorContext.ts
import { useEffect, useCallback as useCallback2, useMemo, useState } from "react";
import { CurrentPage as CurrentPage2, CompanyType as CompanyType2 } from "@tasama/ui";
var useBusinessAdvisorContext = (props = {}) => {
  const {
    urlOverride,
    stepperStepOverride,
    isAuthenticated = false,
    stepperStore,
    companyType = CompanyType2.ANONYMOUS
  } = props;
  const { context, setContext } = useBusinessAdvisorStore();
  const selectedServiceName = useBusinessAdvisorStore(
    (state) => state.selectedServiceName
  );
  const tabOverride = useBusinessAdvisorStore(
    (state) => state.tabOverride
  );
  const relatedServiceOverride = useBusinessAdvisorStore(
    (state) => state.relatedServiceOverride
  );
  const recordIdOverride = useBusinessAdvisorStore(
    (state) => state.recordIdOverride
  );
  const hierarchyPathOverride = useBusinessAdvisorStore(
    (state) => state.hierarchyPathOverride
  );
  const [currentUrl, setCurrentUrl] = useState(() => {
    if (urlOverride) return urlOverride;
    if (typeof window !== "undefined") return window.location.href;
    return "";
  });
  useEffect(() => {
    if (urlOverride) return;
    const updateUrl = () => setCurrentUrl(window.location.href);
    window.addEventListener("popstate", updateUrl);
    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);
    history.pushState = (...args) => {
      originalPushState(...args);
      updateUrl();
    };
    history.replaceState = (...args) => {
      originalReplaceState(...args);
      updateUrl();
    };
    return () => {
      window.removeEventListener("popstate", updateUrl);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, [urlOverride]);
  const currentStepperStep = useMemo(
    () => stepperStepOverride || stepperStore?.currentStep?.id,
    [stepperStepOverride, stepperStore]
  );
  const { currentPage, currentTab: detectedTab } = useMemo(
    () => detectPageContext({
      url: currentUrl,
      isAuthenticated,
      stepperCurrentStep: currentStepperStep
    }),
    [currentUrl, isAuthenticated, currentStepperStep]
  );
  const currentTab = useMemo(() => {
    if (tabOverride !== null) return tabOverride;
    return detectedTab;
  }, [detectedTab, tabOverride]);
  const apiCompanyType = companyType;
  const detectedContext = useMemo(
    () => createContext(
      currentPage,
      apiCompanyType,
      currentTab,
      relatedServiceOverride ?? (currentPage === CurrentPage2.PORTAL_SERVICE_CATALOGUE ? selectedServiceName : null),
      recordIdOverride,
      hierarchyPathOverride
    ),
    [
      currentPage,
      apiCompanyType,
      currentTab,
      selectedServiceName,
      relatedServiceOverride,
      recordIdOverride,
      hierarchyPathOverride
    ]
  );
  useEffect(() => {
    setContext(detectedContext);
  }, [detectedContext, setContext]);
  const updateContext = useCallback2(
    (newContext) => setContext({ ...detectedContext, ...newContext }),
    [detectedContext, setContext]
  );
  const resetContext = useCallback2(
    () => setContext(detectedContext),
    [detectedContext, setContext]
  );
  const getContextForPage = useCallback2(
    (page, companyType2) => createContext(page, companyType2 || apiCompanyType),
    [apiCompanyType]
  );
  return {
    context: context || detectedContext,
    currentPage,
    apiCompanyType,
    detectedContext,
    currentUrl,
    currentStepperStep,
    updateContext,
    resetContext,
    getContextForPage,
    isLoginPage: currentPage === CurrentPage2.LOGIN,
    isOnboardingPage: currentPage.toString().startsWith("ONBOARDING"),
    isPortalPage: currentPage.toString().startsWith("PORTAL")
  };
};

// src/hooks/useAdvisorModalContent.ts
import { useState as useState2, useCallback as useCallback4, useEffect as useEffect2, useMemo as useMemo2 } from "react";

// src/hooks/useBusinessAdvisorSendMessage.ts
import { useCallback as useCallback3 } from "react";
import { useApiMutation as useApiMutation2 } from "@tasama/api-client-query";
import { useTranslation as useTranslation2 } from "@tasama/i18n";
var useBusinessAdvisorSendMessage = (isAuthenticated = false) => {
  const { t } = useTranslation2("common");
  const {
    conversationSessionId,
    context,
    addMessage,
    setLoading,
    setError,
    setSendMessageError,
    setNextActions,
    setCta,
    setCtaMetadata
  } = useBusinessAdvisorStore();
  const sendMessageMutation = useApiMutation2(
    (_data) => {
      if (!conversationSessionId)
        throw new Error("No conversation session ID available");
      return getBusinessAdvisorUrl(
        `/session/${conversationSessionId}/message`,
        isAuthenticated
      );
    },
    "POST",
    {
      onSuccess: (data) => {
        const success = data.data?.success ?? data.success ?? (data.status >= 200 && data.status < 300);
        if (success) {
          setSendMessageError(null);
          if (data.data?.message) {
            const assistantMessage = {
              id: generateMessageId(),
              message: data.data.message,
              role: "assistant",
              timestamp: (/* @__PURE__ */ new Date()).toISOString(),
              cta: data.data.cta || [],
              cta_metadata: data.data.cta_metadata ?? void 0,
              ...data.data.links?.length && { links: data.data.links }
            };
            addMessage(assistantMessage);
          }
          if (data.data?.next_actions) {
            setNextActions(data.data.next_actions);
          }
          if (data.data?.cta) {
            setCta(data.data.cta);
          }
          setCtaMetadata(data.data?.cta_metadata ?? null);
        } else {
          setSendMessageError({
            message: data.message || t("businessAdvisor.errors.sendFailed"),
            code: "SEND_FAILED"
          });
        }
      },
      onError: (error) => {
        setSendMessageError({
          message: error.message || t("businessAdvisor.errors.sendFailed"),
          code: error.code,
          details: error.details
        });
      }
    }
  );
  const sendMessage = useCallback3(
    async (message, isNextAction = false, messageContext) => {
      try {
        if (!conversationSessionId) {
          setError({
            message: t("businessAdvisor.errors.noSessionAvailable"),
            code: "NO_SESSION"
          });
          return false;
        }
        if (!message.trim()) {
          setError({
            message: t("businessAdvisor.errors.emptyMessage"),
            code: "EMPTY_MESSAGE"
          });
          return false;
        }
        const currentContext = messageContext || context;
        if (!currentContext) {
          setError({
            message: t("businessAdvisor.errors.noContext"),
            code: "NO_CONTEXT"
          });
          return false;
        }
        setLoading(true);
        setError(null);
        setSendMessageError(null);
        const userMessage = {
          id: generateMessageId(),
          message: message.trim(),
          role: "user",
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          is_next_action: isNextAction
        };
        addMessage(userMessage);
        await sendMessageMutation.mutateAsync({
          context: currentContext,
          message: message.trim(),
          is_next_action: isNextAction
        });
        return true;
      } catch {
        return false;
      } finally {
        setLoading(false);
      }
    },
    [
      conversationSessionId,
      context,
      sendMessageMutation,
      addMessage,
      setLoading,
      setError
    ]
  );
  const sendSuggestion = useCallback3(
    async (suggestion) => sendMessage(suggestion, true),
    [sendMessage]
  );
  return {
    sendMessage,
    sendSuggestion,
    isLoading: sendMessageMutation.isPending,
    error: useBusinessAdvisorStore((state) => state.error),
    sendMessageError: useBusinessAdvisorStore(
      (state) => state.sendMessageError
    ),
    canSendMessage: Boolean(conversationSessionId && context)
  };
};

// src/hooks/useAdvisorModalContent.ts
var useAdvisorModalContent = ({
  suggestions,
  isAuthenticated = false,
  stepperStore,
  companyType,
  onboardingUrl = ""
}) => {
  const [isConversationMode, setIsConversationMode] = useState2(false);
  const [isResetting, setIsResetting] = useState2(false);
  const nextActions = useBusinessAdvisorStore(
    (state) => state.nextActions || []
  );
  const cta = useBusinessAdvisorStore(
    (state) => state.cta || []
  );
  const conversationSessionId = useBusinessAdvisorStore(
    (state) => state.conversationSessionId
  );
  const messages = useBusinessAdvisorStore(
    (state) => state.messages || []
  );
  const title = useBusinessAdvisorStore(
    (state) => state.title
  );
  const subtitle = useBusinessAdvisorStore(
    (state) => state.subtitle
  );
  const {
    sendMessage,
    isLoading: isSending,
    error: sendMessageError,
    sendMessageError: specificSendError
  } = useBusinessAdvisorSendMessage(isAuthenticated);
  const { initConversation, isLoading: isInitializingConversation } = useBusinessAdvisorInit(isAuthenticated);
  const { context } = useBusinessAdvisorContext({
    isAuthenticated,
    ...stepperStore && { stepperStore },
    ...companyType && { companyType }
  });
  const globalError = useBusinessAdvisorStore(
    (state) => state.error
  );
  const hasApiError = Boolean(globalError || sendMessageError);
  const hasSendMessageError = Boolean(specificSendError);
  const dynamicSuggestions = nextActions.length > 0 ? nextActions.map((a) => a.text) : suggestions;
  const ctaMetadata = useBusinessAdvisorStore(
    (state) => state.ctaMetadata
  );
  const resetStore = useBusinessAdvisorStore(
    (state) => state.resetStore
  );
  const dynamicCta = mapCtaToItems(
    cta,
    onboardingUrl,
    ctaMetadata
  );
  const handleSuggestionClick = useCallback4(
    async (suggestion) => {
      try {
        setIsConversationMode(true);
        await sendMessage(suggestion, true);
      } catch {
      }
    },
    [sendMessage]
  );
  const handleTextMessageSend = useCallback4(
    async (messageText) => {
      if (!messageText.trim()) return;
      try {
        setIsConversationMode(true);
        await sendMessage(messageText, false);
      } catch {
      }
    },
    [sendMessage]
  );
  const handleResetConversation = useCallback4(async () => {
    try {
      setIsResetting(true);
      setIsConversationMode(false);
      resetStore();
      if (context) await initConversation(context);
    } catch {
    } finally {
      setIsResetting(false);
    }
  }, [context, initConversation, resetStore]);
  useEffect2(() => {
    if (messages.length > 0 && !isConversationMode) {
      setIsConversationMode(true);
    }
  }, [messages.length, isConversationMode]);
  useEffect2(() => {
    if (!conversationSessionId) {
      setIsConversationMode(false);
    }
  }, [conversationSessionId]);
  const mapCta = useMemo2(
    () => (ctaTypes, metadata) => mapCtaToItems(ctaTypes, onboardingUrl, metadata),
    [onboardingUrl]
  );
  return {
    isConversationMode,
    isResetting,
    isInitializingConversation,
    dynamicSuggestions,
    hasApiError,
    hasSendMessageError,
    isSending,
    messages,
    nextActions,
    conversationSessionId,
    title,
    subtitle,
    handleSuggestionClick,
    handleTextMessageSend,
    handleResetConversation,
    dynamicCta,
    mapCta
  };
};

// src/hooks/useReverseInfiniteScroll.ts
import { useRef as useRef2, useLayoutEffect, useEffect as useEffect4, useCallback as useCallback6 } from "react";

// src/hooks/useBusinessAdvisorMessages.ts
import { useCallback as useCallback5, useEffect as useEffect3, useRef } from "react";
import { useInfiniteApiQuery } from "@tasama/api-client-query";
import { useTranslation as useTranslation3 } from "@tasama/i18n";
var MESSAGES_LIMIT = 6;
var useBusinessAdvisorMessages = (isAuthenticated = false) => {
  const { t } = useTranslation3("common");
  const {
    conversationSessionId,
    messages,
    setError,
    setNextActions,
    setCta,
    setMessages
  } = useBusinessAdvisorStore();
  const shouldFetchRef = useRef(false);
  const hasExistingDataRef = useRef(false);
  useEffect3(() => {
    const hasStoreData = Boolean(conversationSessionId && messages.length > 0);
    hasExistingDataRef.current = hasStoreData;
  }, [conversationSessionId, messages.length]);
  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetch,
    error: queryError
  } = useInfiniteApiQuery(
    ["business-advisor-messages", conversationSessionId ?? ""],
    {
      getEndpoint: (pageParam) => {
        const baseUrl = getBusinessAdvisorUrl("/session", isAuthenticated);
        const endpoint = `${baseUrl}/${conversationSessionId}/messages?offset=${pageParam}&limit=${MESSAGES_LIMIT}`;
        return endpoint;
      },
      initialPageParam: 0,
      getNextPageParam: (lastPage, allPages) => {
        const totalMessages = lastPage?.data?.total_messages || lastPage?.data?.total_count || 0;
        const loadedCount = allPages.reduce(
          (acc, page) => acc + (page?.data?.messages?.length || 0),
          0
        );
        const nextPageNumber = allPages.length;
        const hasMore = loadedCount < totalMessages;
        return hasMore ? nextPageNumber : void 0;
      },
      // Disable automatic fetching - only fetch when explicitly called via enableFetch() or fetchNextPage()
      // This prevents the automatic offset 1 call when modal opens
      enabled: Boolean(conversationSessionId && shouldFetchRef.current),
      staleTime: 3e4,
      retry: 2
    }
  );
  useEffect3(() => {
    if (!data?.pages) return;
    const latestPage = data.pages[data.pages.length - 1];
    const latestPageData = latestPage?.data;
    const newMessages = latestPageData?.messages || [];
    if (latestPageData?.next_actions !== void 0) {
      setNextActions(latestPageData.next_actions);
    }
    if (Array.isArray(newMessages) && newMessages.length > 0) {
      const current = Array.isArray(messages) ? messages : [];
      const hasClientGeneratedIds = current.some(
        (m) => typeof m.id === "string" && m.id.startsWith("msg_")
      );
      if (current.length === 0 || hasClientGeneratedIds) {
        setMessages(newMessages);
      } else {
        const existingIds = new Set(
          current.map((m) => m.id)
        );
        const filteredNew = newMessages.filter(
          (m) => !existingIds.has(m.id)
        );
        if (filteredNew.length > 0) {
          setMessages([...filteredNew, ...current]);
        }
      }
    }
    if (Array.isArray(newMessages) && newMessages.length > 0) {
      const lastMessage = newMessages[newMessages.length - 1];
      if (Array.isArray(lastMessage?.cta)) {
        setCta(lastMessage.cta);
      }
    }
    setError(null);
  }, [data]);
  useEffect3(() => {
    if (queryError) {
      setError({
        message: queryError.message || t("businessAdvisor.errors.fetchMessagesFailed"),
        code: queryError.code || "FETCH_ERROR",
        details: queryError.details
      });
    }
  }, [queryError, setError, t]);
  const enableFetch = useCallback5(() => {
    shouldFetchRef.current = true;
    if (conversationSessionId) {
      refetch();
    }
  }, [conversationSessionId, refetch, data]);
  const refreshMessages = useCallback5(async () => {
    try {
      if (!conversationSessionId) {
        setError({
          message: t("businessAdvisor.errors.noSessionAvailable"),
          code: "NO_SESSION"
        });
        return false;
      }
      setError(null);
      shouldFetchRef.current = true;
      const result = await refetch();
      if (result.error) {
        setError({
          message: result.error.message || t("businessAdvisor.errors.refreshMessagesFailed"),
          code: result.error.code || "REFRESH_ERROR",
          details: result.error.details
        });
        return false;
      }
      return Boolean(result.data);
    } catch (error) {
      setError({
        message: error instanceof Error ? error.message : t("businessAdvisor.errors.refreshMessagesFailed"),
        code: error instanceof Error && "code" in error ? error.code : "REFRESH_ERROR",
        details: error
      });
      return false;
    }
  }, [conversationSessionId, refetch, setError, t]);
  const loadMoreMessages = useCallback5(async () => {
    try {
      if (!conversationSessionId) {
        return false;
      }
      if (isFetchingNextPage) {
        return false;
      }
      if (!hasNextPage) {
        return false;
      }
      setError(null);
      const result = await fetchNextPage();
      return !result.error;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : t("businessAdvisor.errors.loadMoreFailed");
      const errorCode = error instanceof Error && "code" in error ? error.code : "LOAD_MORE_ERROR";
      setError({
        message: errorMessage,
        code: errorCode,
        details: error
      });
      return false;
    }
  }, [
    conversationSessionId,
    hasNextPage,
    isFetchingNextPage,
    setError,
    fetchNextPage,
    messages.length,
    t
  ]);
  const totalCount = data?.pages?.[0]?.data?.total_messages || data?.pages?.[0]?.data?.total_count || 0;
  return {
    messages,
    messageCount: messages.length,
    latestMessage: messages.length > 0 ? messages[messages.length - 1] : null,
    hasMessages: messages.length > 0,
    totalCount,
    isLoading,
    error: useBusinessAdvisorStore((state) => state.error),
    canFetchMessages: Boolean(conversationSessionId),
    hasExistingData: hasExistingDataRef.current,
    hasMoreMessages: hasNextPage ?? false,
    isLoadingMore: isFetchingNextPage,
    refreshMessages,
    enableFetch,
    loadMoreMessages
  };
};

// src/hooks/useReverseInfiniteScroll.ts
var useReverseInfiniteScroll = ({
  enableLoadMore = true,
  autoScrollToBottom = true,
  testID: _testID,
  bottomThreshold: _bottomThreshold = 10
} = {}) => {
  const containerRef = useRef2(null);
  const lastMessageCountRef = useRef2(0);
  const isRestoringRef = useRef2(false);
  const prevScrollTopRef = useRef2(0);
  const prevScrollHeightRef = useRef2(0);
  const messages = useBusinessAdvisorStore(
    (state) => state.messages || []
  );
  const { loadMoreMessages, hasMoreMessages, isLoadingMore } = useBusinessAdvisorMessages();
  const setRef = useCallback6((node) => {
    containerRef.current = node;
  }, []);
  const handleScroll = useCallback6(() => {
    const el = containerRef.current;
    if (!el) return;
    if (isRestoringRef.current) return;
    const isNearTop = el.scrollTop < 10;
    if (enableLoadMore && isNearTop && hasMoreMessages && !isLoadingMore) {
      prevScrollTopRef.current = el.scrollTop;
      prevScrollHeightRef.current = el.scrollHeight;
      isRestoringRef.current = true;
      loadMoreMessages();
    }
  }, [enableLoadMore, hasMoreMessages, isLoadingMore, loadMoreMessages]);
  useEffect4(() => {
    const el = containerRef.current;
    if (!el) return;
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);
  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const messageCountChanged = messages.length !== lastMessageCountRef.current;
    if (!messageCountChanged) return;
    if (isRestoringRef.current) {
      const prevTop = prevScrollTopRef.current;
      const prevHeight = prevScrollHeightRef.current;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const newHeight = el.scrollHeight;
          const diff = newHeight - prevHeight;
          el.scrollTop = prevTop + diff;
          requestAnimationFrame(() => {
            const finalHeight = el.scrollHeight;
            const finalDiff = finalHeight - prevHeight;
            el.scrollTop = prevTop + finalDiff;
          });
          isRestoringRef.current = false;
        });
      });
    } else if (lastMessageCountRef.current === 0) {
      if (autoScrollToBottom) {
        el.scrollTop = el.scrollHeight;
      }
    }
    lastMessageCountRef.current = messages.length;
  }, [messages, autoScrollToBottom]);
  const scrollToBottom = useCallback6(() => {
    const el = containerRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, []);
  const onMessageSent = useCallback6(() => {
    requestAnimationFrame(() => {
      scrollToBottom();
    });
  }, [scrollToBottom]);
  return {
    scrollContainerRef: setRef,
    scrollToBottom,
    onMessageSent
  };
};

// src/container/BusinessAdvisorContainer.tsx
import { useTranslation as useTranslation4 } from "@tasama/i18n";
import { jsx, jsxs } from "react/jsx-runtime";
var BusinessAdvisorContainer = ({
  stepperStore,
  companyType,
  isAuthenticated = false,
  testID = BUTTON_TEST_ID,
  onCtaClick,
  onNavigate,
  onboardingUrl = ""
}) => {
  const { t } = useTranslation4("common");
  const setError = useBusinessAdvisorStore((s) => s.setError);
  const isInitialized = useBusinessAdvisorStore((s) => s.isInitialized);
  const [isOpen, setIsOpen] = useState3(false);
  const [textAreaValue, setTextAreaValue] = useState3("");
  const [isExpanded, setIsExpanded] = useState3(false);
  const [isClosing, setIsClosing] = useState3(false);
  const isMobile = useIsMobile();
  const isMobileOverlayOpen = useIsMobileOverlayOpen();
  const { initConversation, isLoading: isInitializing } = useBusinessAdvisorInit(isAuthenticated);
  const { context } = useBusinessAdvisorContext({
    isAuthenticated,
    ...stepperStore && { stepperStore },
    ...companyType && { companyType }
  });
  const {
    isConversationMode,
    isResetting,
    isInitializingConversation,
    dynamicSuggestions,
    dynamicCta,
    hasApiError,
    hasSendMessageError,
    isSending,
    messages,
    nextActions,
    conversationSessionId,
    subtitle,
    handleSuggestionClick,
    handleTextMessageSend,
    handleResetConversation,
    mapCta
  } = useAdvisorModalContent({
    suggestions: [],
    isAuthenticated,
    onboardingUrl,
    ...stepperStore && { stepperStore },
    ...companyType && { companyType }
  });
  const { scrollContainerRef, onMessageSent, scrollToBottom } = useReverseInfiniteScroll({
    testID: "advisor-modal-scroll",
    bottomThreshold: 10,
    autoScrollToBottom: true,
    enableLoadMore: true
  });
  const {
    enableFetch,
    isLoading: isFetchingMessages,
    isLoadingMore
  } = useBusinessAdvisorMessages(isAuthenticated);
  const shouldOpen = useBusinessAdvisorStore((s) => s.shouldOpen);
  const pendingPrompt = useBusinessAdvisorStore((s) => s.pendingPrompt);
  const setShouldOpen = useBusinessAdvisorStore((s) => s.setShouldOpen);
  const setPendingPrompt = useBusinessAdvisorStore((s) => s.setPendingPrompt);
  const pendingPromptRef = React.useRef(null);
  React.useEffect(() => {
    if (!shouldOpen) return;
    setShouldOpen(false);
    pendingPromptRef.current = pendingPrompt;
    setPendingPrompt(null);
    setError(null);
    setIsOpen(true);
    const hasActive = Boolean(conversationSessionId && isInitialized);
    if (hasActive) {
      if (pendingPromptRef.current) {
        handleTextMessageSend(pendingPromptRef.current);
        pendingPromptRef.current = null;
      }
    } else {
      void (async () => {
        if (context) {
          try {
            const success = await initConversation(context);
            if (!success) {
              setError(t("businessAdvisor.errors.initConversation"));
            }
          } catch (error) {
            setError(
              error instanceof Error ? error.message : t("businessAdvisor.errors.initConversation")
            );
          }
        }
      })();
    }
  }, [shouldOpen]);
  React.useEffect(() => {
    if (!conversationSessionId || !pendingPromptRef.current) return;
    const prompt = pendingPromptRef.current;
    pendingPromptRef.current = null;
    handleTextMessageSend(prompt);
  }, [conversationSessionId, handleTextMessageSend]);
  const isFirstLoadRef = React.useRef(true);
  React.useEffect(() => {
    if (!conversationSessionId) return;
    if (messages.length > 0 && isFirstLoadRef.current) {
      requestAnimationFrame(() => {
        scrollToBottom();
      });
      isFirstLoadRef.current = false;
    }
  }, [messages.length, conversationSessionId, scrollToBottom]);
  const lastMessageIdRef = React.useRef(null);
  React.useEffect(() => {
    if (!messages.length) return;
    const lastMessage = messages[messages.length - 1];
    if (lastMessage && lastMessage.role === "assistant" && lastMessage.id !== lastMessageIdRef.current) {
      scrollToBottom();
      lastMessageIdRef.current = lastMessage.id;
    }
  }, [messages, scrollToBottom]);
  const prevIsOpenRef = React.useRef(false);
  React.useEffect(() => {
    if (!prevIsOpenRef.current && isOpen) {
      if (messages.length > 0) {
        requestAnimationFrame(() => {
          scrollToBottom();
        });
      }
    }
    prevIsOpenRef.current = isOpen;
  }, [isOpen, messages.length, scrollToBottom]);
  const onSuggestionClick = (suggestion) => {
    onMessageSent();
    handleSuggestionClick(suggestion);
  };
  const handleTextChange = useCallback7((value) => {
    if (value.length <= MAX_CHARACTERS) {
      setTextAreaValue(value);
    }
  }, []);
  const handleClick = () => {
    try {
      if (isOpen) {
        handleCloseWithAnimation();
        return;
      }
      setIsOpen(true);
      const hasActive = Boolean(conversationSessionId && isInitialized);
      if (conversationSessionId && hasActive) {
        enableFetch();
      } else if (!conversationSessionId && !hasActive) {
        void (async () => {
          if (context) {
            try {
              const success = await initConversation(context);
              if (!success) {
                setError(t("businessAdvisor.errors.initConversation"));
              }
            } catch (error) {
              setError(
                error instanceof Error ? error.message : t("businessAdvisor.errors.initConversation")
              );
            }
          }
        })();
      }
    } catch (error) {
      setError(
        error instanceof Error ? error.message : t("businessAdvisor.errors.unexpected")
      );
    }
  };
  const handleClose = useCallback7(() => setIsOpen(false), []);
  const handleCloseWithAnimation = useCallback7(() => {
    if (isOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsClosing(false);
      }, DELAYS.MODAL_CLOSE_ANIMATION);
    }
  }, [isOpen]);
  const handleCtaClick = useCallback7(
    (item) => {
      handleCloseWithAnimation();
      onCtaClick?.(item);
    },
    [handleCloseWithAnimation, onCtaClick]
  );
  const renderLinks = useCallback7(
    (links) => /* @__PURE__ */ jsx("div", { className: "mt-lg", children: /* @__PURE__ */ jsx(
      Suggestions,
      {
        suggestions: [],
        dynamicCta: links.map((link) => ({
          label: link.text,
          url: link.redirect_url,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          type: link.target
        })),
        onCtaClick: (item) => {
          handleCloseWithAnimation();
          onNavigate?.(item.url);
        },
        isAuthenticated
      }
    ) }),
    [handleCloseWithAnimation, onNavigate, isAuthenticated]
  );
  const handleToggleExpand = useCallback7(() => setIsExpanded((v) => !v), []);
  const handleSend = useCallback7(() => {
    const trimmed = textAreaValue.trim();
    if (!trimmed) return;
    onMessageSent();
    handleTextMessageSend(trimmed);
    setTextAreaValue("");
  }, [textAreaValue, onMessageSent, handleTextMessageSend]);
  const hideFloatingTrigger = isMobile && isMobileOverlayOpen;
  return /* @__PURE__ */ jsxs(ErrorBoundary, { testID: "business-ai-entry-error-boundary", children: [
    !hideFloatingTrigger && /* @__PURE__ */ jsxs(
      "div",
      {
        className: "fixed bottom-sm end-sm z-business-advisor pointer-events-none flex items-center justify-center",
        "aria-live": "polite",
        children: [
          /* @__PURE__ */ jsx(
            Lottie,
            {
              animationData: ba_ai_avatar_default,
              loop: true,
              autoplay: true,
              style: { width: 90, height: 90 }
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "pointer-events-auto w-[65px] h-[65px] absolute rounded-full", children: /* @__PURE__ */ jsx(
            BusinessAdvisorButton,
            {
              content: t("businessAdvisor.button.askAi"),
              testID: "business-ai-tooltip",
              children: /* @__PURE__ */ jsx(
                Button,
                {
                  "data-testid": testID,
                  iconPosition: "none",
                  variant: "quaternary",
                  onClick: handleClick,
                  className: "w-[65px] h-[65px] bg-transparent rounded-full",
                  "aria-label": isOpen ? t("businessAdvisor.button.close") : t("businessAdvisor.button.open"),
                  children: /* @__PURE__ */ jsx("span", {})
                }
              )
            }
          ) })
        ]
      }
    ),
    isOpen && /* @__PURE__ */ jsx(
      Suspense,
      {
        fallback: /* @__PURE__ */ jsx("div", { className: "min-h-[400px] flex items-center justify-center", children: /* @__PURE__ */ jsx(
          Loader,
          {
            size: "lg",
            label: t("businessAdvisor.loader.loading"),
            showLabel: true,
            testID: "business-ai-modal-loader"
          }
        ) }),
        children: /* @__PURE__ */ jsx(
          AdvisorModal,
          {
            title: t("businessAdvisor.headerTitle"),
            description: t("businessAdvisor.headerDescription"),
            textAreaValue,
            onTextAreaChange: handleTextChange,
            onClose: handleClose,
            onSend: handleSend,
            bottomIconName: "ArrowUp",
            loading: false,
            testID: "business-ai-advisor-modal",
            isExpanded,
            ...!isMobile && { onToggleExpand: handleToggleExpand },
            hasApiError,
            scrollContainerRef,
            isClosing,
            messages,
            onResetConversation: handleResetConversation,
            isLoading: isSending,
            isAuthenticated,
            children: /* @__PURE__ */ jsx(
              AdvisorModalContent,
              {
                isConversationMode,
                isResetting,
                isInitializingConversation,
                isInitializing,
                dynamicSuggestions,
                dynamicCta,
                hasApiError,
                hasSendMessageError,
                isSending,
                isFetchingMessages,
                isLoadingMoreMessages: isLoadingMore,
                messages,
                nextActions,
                conversationSessionId,
                subtitle,
                isExpanded,
                onSuggestionClick,
                onCtaClick: handleCtaClick,
                renderLinks,
                isAuthenticated,
                testID: "advisor-modal-content-section",
                mapCta
              }
            )
          }
        )
      }
    )
  ] });
};
BusinessAdvisorContainer.displayName = "BusinessAdvisorContainer";

// src/components/BAContextBridge.tsx
import { useEffect as useEffect5 } from "react";
function useBAContextBridge({
  tab,
  relatedService,
  recordId,
  hierarchyPath
} = {}) {
  const setTabOverride = useBusinessAdvisorStore((s) => s.setTabOverride);
  const setRelatedServiceOverride = useBusinessAdvisorStore(
    (s) => s.setRelatedServiceOverride
  );
  const setRecordIdOverride = useBusinessAdvisorStore(
    (s) => s.setRecordIdOverride
  );
  const setHierarchyPathOverride = useBusinessAdvisorStore(
    (s) => s.setHierarchyPathOverride
  );
  useEffect5(() => {
    if (tab === void 0) return;
    setTabOverride(tab);
    return () => {
      if (useBusinessAdvisorStore.getState().tabOverride === tab) {
        setTabOverride(null);
      }
    };
  }, [tab, setTabOverride]);
  useEffect5(() => {
    if (relatedService === void 0) return;
    setRelatedServiceOverride(relatedService);
    return () => {
      if (useBusinessAdvisorStore.getState().relatedServiceOverride === relatedService) {
        setRelatedServiceOverride(null);
      }
    };
  }, [relatedService, setRelatedServiceOverride]);
  useEffect5(() => {
    if (recordId === void 0) return;
    setRecordIdOverride(recordId);
    return () => {
      if (useBusinessAdvisorStore.getState().recordIdOverride === recordId) {
        setRecordIdOverride(null);
      }
    };
  }, [recordId, setRecordIdOverride]);
  useEffect5(() => {
    if (hierarchyPath === void 0) return;
    setHierarchyPathOverride(hierarchyPath);
    return () => {
      if (useBusinessAdvisorStore.getState().hierarchyPathOverride === hierarchyPath) {
        setHierarchyPathOverride(null);
      }
    };
  }, [hierarchyPath, setHierarchyPathOverride]);
}
function BAContextBridge(props) {
  useBAContextBridge(props);
  return null;
}
export {
  BAContextBridge,
  BA_RELATED_SERVICE_BUSINESS_LANDING,
  BusinessAdvisorContainer,
  BusinessLandingTabs,
  KybTabs,
  MsaTabs,
  MyAccountTabs,
  MyServicesTabs,
  NdaTabs,
  PAGE_TAB_MAPPINGS,
  PortalPage,
  RequestedServiceTabs,
  ServiceCatalogueTabs,
  ServiceDetailTabs,
  SupportTicketsTabs,
  URL_TO_PAGE_MAP,
  clearBusinessAdvisorSession,
  createContext,
  createLoggedInContext,
  createLoggedInContextFromLocation,
  detectCurrentPage,
  generateMessageId,
  mapCompanyTypeForApi,
  resetBusinessAdvisorConversation,
  setBACurrentTab,
  setBARelatedService,
  triggerBAWithPrompt,
  useAdvisorModalContent,
  useBAContextBridge,
  useBusinessAdvisorContext,
  useBusinessAdvisorInit,
  useBusinessAdvisorMessages,
  useBusinessAdvisorSendMessage,
  useBusinessAdvisorStore,
  useReverseInfiniteScroll
};
//# sourceMappingURL=index.js.map